import script from "./AudioStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudioStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./AudioStylePanel.vue?vue&type=style&index=0&id=5d723d50&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d723d50"]])

export default __exports__